import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadingService, AlertService } from 'ngx-kuv-tools';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { ModalDeleteComponent } from 'src/app/utils/modal-delete/modal-delete.component';
import { ProductoService } from '../producto.service';
import { RecetaService } from '../receta.service';

@Component({
  selector: 'app-receta-create',
  templateUrl: './receta-create.component.html',
  styleUrls: ['./receta-create.component.scss']
})
export class RecetaCreateComponent implements OnInit {

  @Input() producto_id: number | null = null;
  productos: any[] = [];
  insumos: any[] = [];
  form: FormGroup = new FormGroup({});

  tableItems: any[] = [];
  tableColumns: any[] = [
    {
      label: 'Insumo',
      value: (element: any, index: number) => {
        return element.nombre;
      }
    }, 
    {
      label: 'Cantidad Gastada',
      value: (element: any, index: number) => {
        return this.formatter.numberFormat(element.cantidad);
      }
    }
  ];
  tableActions: any[] = [
    {
      icon: 'trash',
      name: 'Eliminar',
      action: (element: any, index: number) => {
        let aux = this.tableItems.slice();
        aux.splice(index, 1);
        this.tableItems = aux;
      }
    }
  ];
  
  constructor(
    private formBuilder: FormBuilder,
    private loading: LoadingService,
    private alerts: AlertService,
    public activeModal: NgbActiveModal,
    public service: RecetaService,
    public productoService: ProductoService,
    public formatter: FormatterService,
    private modalService: NgbModal
  ) {}
  
  ngOnInit() {
    this.form = this.formBuilder.group({
      producto_id: ['', [Validators.required]],
      nombre: ['', [Validators.required]],
      cantidad: ['', [Validators.required]],
      insumo_id: [''],
      cantidad_insumo: [''],
    });

    this.loadProductos();
    this.loadInsumos();
    if (this.producto_id) {
      this.form.patchValue({ producto_id: this.producto_id });
      this.form.controls['producto_id'].disable();
    }
  }

  loadProductos(){
    this.loading.show()
    this.productoService.select().subscribe({
      next: (res: any) => {
        this.loading.hide();
        this.productos = res;
      }, error: (err: any) => {
        this.loading.hide();
        if(err.response) this.alerts.addAlert(err.response, 'danger');
      }
    });
  }

  loadInsumos() {
    this.loading.show()
    this.productoService.select().subscribe({
      next: (res: any) => {
        this.loading.hide();
        this.insumos = res;
      }, error: (err: any) => {
        this.loading.hide();
        if (err.response) this.alerts.addAlert(err.response, 'danger');
      }
    });
  }

  searchFn(term: any, item: any) {
    const removeAccents = (str: any) => {
      return str.normalize("NFD").replace(/[̀-ͯ]/g, "");
    }
    let terms = removeAccents(term.toLowerCase()).split(' ');
    let result = true;
    let p = removeAccents(([item.nombre, item.codigo_barra, item.sku].join(' ')).toLowerCase());
    terms.forEach((t: any) => {
      result = result && p.includes(t);
    });
    return result;
  }

  addInsumo(): any{
    let insumo = this.insumos.find((e: any) => e.id == this.form.value.insumo_id);
    let cantidad = this.form.value.cantidad_insumo;
    if (!insumo) return this.alerts.addAlert('Debe seleccionar un insumo para agregarlo a la receta.', 'warning');
    if (!cantidad) return this.alerts.addAlert('Debe ingresar una cantidad antes de agregar el insumo a la receta.', 'warning');
    let aux = this.tableItems.slice();
    aux.push({
      nombre: insumo.nombre,
      producto_id: insumo.id,
      cantidad: cantidad,
    })
    this.tableItems = aux;
    this.form.patchValue({insumo_id: null, cantidad_insumo: null})
  }
  
  completarRegistro(){
    if (this.form.invalid) {
      this.alerts.addAlert('Hay campos en el formulario que no han sido llenados.', 'warning');
      return this.form.markAllAsTouched();
    }
    if(this.tableItems.length == 0) {
      const modalRef = this.modalService.open(ModalDeleteComponent,{ centered: true });
      modalRef.componentInstance.texto = 'Está a punto de registrar una receta sin insumos gastados. ¿Está seguro de que desea continuar?';
      modalRef.componentInstance.textoAceptar = 'Aceptar';
      modalRef.result.then((result: any) => {
        this.guardar();
      }, (reason: any) => {});
    } else {
      this.guardar();
    }
  }

  guardar(){
    this.form.controls['producto_id'].enable();
    this.loading.show();
    let data = Object.assign({}, this.form.value);
    data.lineas = this.tableItems;
    this.service.create(data).subscribe({
      next: (res) => {
        this.loading.hide();
        this.activeModal.close(res.model);
      }, error: (err) => {
        console.error(err);
        this.loading.hide();
        this.alerts.addAlert("No se pudo guardar la receta.", "danger");
      }
    })
  }

}
